import { render, staticRenderFns } from "./CarsTable.vue?vue&type=template&id=ff16b088&scoped=true&"
import script from "./CarsTable.vue?vue&type=script&lang=js&"
export * from "./CarsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff16b088",
  null
  
)

export default component.exports